export const categoriesOptionsList = list =>
  list.map(el => ({ label: el, value: el }));
